export const GET_FLOW_PROJECT_REQUEST = 'GET_FLOW_PROJECT_REQUEST';
export const GET_FLOW_PROJECT_SUCCESS = 'GET_FLOW_PROJECT_SUCCESS';
export const GET_FLOW_PROJECT_ERROR = 'GET_FLOW_PROJECT_ERROR';

export const SET_FLOW_PROJECT_LAST_SYNC_DATE =
  'SET_FLOW_PROJECT_LAST_SYNC_DATE';
